import { diditInboxQueryKeys as e } from "./diditInboxQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { verificationApi as n } from "@maat/api-main";
//#region src/verification/admin/useDiditInboxQuery.ts
var r = (r = {}) => {
	let { status: i, sessionId: a } = r;
	return t({
		queryKey: e.list(i, a),
		fetchPage: (e) => n.adminListDiditInbox({
			status: i,
			sessionId: a,
			page: e
		}),
		key: "items"
	});
};
//#endregion
export { r as useDiditInboxQuery };
